import { getBrandValueLink } from "@faire/deprecated-retailer-visitor-shared/consts/allBrandsLinks";
import { THREE_LETTER_EUROPE_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_EUROPE_COUNTRY_CODES";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { StrictLocalizeFunction } from "@faire/web/common/localization";

interface ICategoryTile {
  cta: string;
  displayName: string;
  imageUrl: string;
}

export const countryBrandValueCollectionTile = (
  country: string = "",
  strictLocalize: StrictLocalizeFunction
): ICategoryTile => {
  switch (country) {
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN:
      return {
        cta: getBrandValueLink("made-in-canada"),
        displayName: strictLocalize({
          id: "Geac2A",
          defaultMessage: "Brands based in Canada",
          description: { text: "Link to shop brands based in Canada" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/fa83f5617a16ce8993d83c49dacafddedda59d7a5bb6289fa98ec4cb8ea36fe8.jpeg",
      };
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.GBR:
      return {
        cta: getBrandValueLink("made-in-uk"),
        displayName: strictLocalize({
          id: "fRDZzv",
          defaultMessage: "Brands based in UK",
          description: { text: "Link to shop brands based in UK" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
      };
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.FRA:
      return {
        cta: getBrandValueLink("made-in-france"),
        displayName: strictLocalize({
          id: "HNbyxv",
          defaultMessage: "Brands based in France",
          description: { text: "Link to shop brands based in France" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
      };
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.DEU:
      return {
        cta: getBrandValueLink("made-in-germany"),
        displayName: strictLocalize({
          id: "U3dTFE",
          defaultMessage: "Brands based in Deutschland",
          description: { text: "Link to shop brands based in Germany" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
      };
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.ITA:
      return {
        cta: getBrandValueLink("made-in-italy"),
        displayName: strictLocalize({
          id: "pCBvi+",
          defaultMessage: "Brands based in Italia",
          description: { text: "Link to shop brands based in Italy" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
      };
    case THREE_LETTER_PRIMARY_COUNTRY_CODES.ESP:
      return {
        cta: getBrandValueLink("made-in-spain"),
        displayName: strictLocalize({
          id: "lxi4M+",
          defaultMessage: "Brands based in España",
          description: { text: "Link to shop brands based in Spain" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
      };
    default:
      if (Object.keys(THREE_LETTER_EUROPE_COUNTRY_CODES).includes(country)) {
        return {
          cta: getBrandValueLink("made-in-europe"),
          displayName: strictLocalize({
            id: "GDZJqS",
            defaultMessage: "Brands based in Europe",
            description: { text: "Link to shop brands based in Europe" },
          }),
          imageUrl:
            "https://cdn.faire.com/fastly/157e6ec2aec60acc2a2d5137d1cf9362a6fccb204633625621aa5f841a9a3644.jpeg",
        };
      }

      return {
        cta: getBrandValueLink("made-in-usa"),
        displayName: strictLocalize({
          id: "k75/Ds",
          defaultMessage: "Brands based in USA",
          description: { text: "Link to shop brands based in USA" },
        }),
        imageUrl:
          "https://cdn.faire.com/fastly/9ea4db62f1ca57e3bfc6fb93775d6ce98bfc9857eefed45316885f3c40599c34.jpeg",
      };
  }
};

export type ICollectionTile = ICategoryTile;
